/**
 * ModerationTopicDetailContent Component
 *
 * Displays the main content section with header and case list for moderation topic detail page.
 */

import { ModerationTopicDetailHeaderSection } from '@moderation/components/ModerationTopicDetailHeaderSection';
import { ModerationCasesTab } from '@moderation/components/ModerationTopicTabNavigation/ModerationCasesTab';
import type { ModerationCommunity } from '@moderation/domain/ModerationCommunity';

import * as styles from '../ModerationTopicDetailPage.css';

interface ModerationTopic {
  id: string;
  name: string;
  severity: 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW';
  cases: number;
  percentChange: number;
  isIncrease: boolean;
  moderators: string[];
  colors: string[];
  description: string;
  openCases: number;
  inProgressCases: number;
  resolvedToday: number;
  averageResolutionTime: string;
}

interface ModerationTopicDetailContentProps {
  /** Community data */
  community: ModerationCommunity | null;
  /** Topic data */
  topic: ModerationTopic;
  /** Community ID */
  communityId: string;
  /** Topic ID */
  topicId: string;
}

export function ModerationTopicDetailContent({ community, topic, communityId, topicId }: ModerationTopicDetailContentProps) {
  return (
    <div>
      {/* Header Section */}
      <div>
        <ModerationTopicDetailHeaderSection community={community} isLoading={false} topic={topic} />
      </div>

      {/* Content Section with Solid Background */}
      <div className={styles.contentSection}>
        <div className={styles.contentContainer}>
          {/* Cases List */}
          <ModerationCasesTab communityId={communityId} topic={topic} topicId={topicId} />
        </div>
      </div>
    </div>
  );
}
